//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    props: {
        residentId: {
            required: true
        }
    },
    data: function data() {
        return {
            headers: [{ title: 'Type', filter: 'transactionType' }, {
                title: 'Starts At',
                filter: 'dateFull'
            }, {
                title: 'End Date',
                filter: 'dateFull'
            }, 'Code', 'Amount'],
            fields: ['is_credit', 'starts_at', 'ends_at', 'code.name', 'true_amount'],
            items: [],
            loading: false
        };
    },
    created: function created() {
        Event.$on('refresh-resident-recurring-transactions', this.load);
        Event.$on('remove-ar-recurring-transaction', this.removeArRecurringTransaction);
        Event.$on('delete-current-transaction', this.deleteTransaction);
        Event.$on('update-ar-recurring-transaction', this.updateArRecurringTransaction);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-resident-recurring-transactions');
        Event.$off('remove-ar-recurring-transaction');
        Event.$off('delete-current-transaction');
        Event.$off('update-ar-recurring-transaction');
    },
    mounted: function mounted() {
        this.load();
    },

    methods: {
        load: function load() {
            var _this = this;

            axios.post(BASE_URL + '/resident/recurring', { id: this.residentId, type: 'current' }).then(function (response) {
                _this.items = response.data;
            });
        },
        removeArRecurringTransaction: function removeArRecurringTransaction(item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/accounts-receivable/transaction/recurring/delete', 'delete-current-transaction');
        },
        deleteTransaction: function deleteTransaction(item) {
            var $idx = this.items.findIndex(function (i) {
                return i.id === item.id;
            });
            this.items.splice($idx, 1);
        },
        updateArRecurringTransaction: function updateArRecurringTransaction(item) {
            Event.$emit('edit-gl-wizard-recurring', item, true);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentRecurringTransactions.vue
// module id = Xr8w
// module chunks = 0 1